import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import { api } from './api';
import { Server } from './types';

export default function Dashboard() {
    const [servers, setServers] = useState<Server[]>([]);
    const navigate = useNavigate();

    useEffect(() => {
        api.get<Server[]>('/servers').then(setServers).catch(() => {});
    }, []);

    const online   = servers.filter(s => s.status === 'up').length;
    const offline  = servers.filter(s => s.status === 'down').length;
    const unknown  = servers.filter(s => s.status === 'unknown').length;

    const stats = [
        { label: 'Всего серверов', value: servers.length, icon: '🖥️' },
        { label: 'Онлайн',        value: online,          icon: '🟢' },
        { label: 'Офлайн',        value: offline,         icon: '🔴' },
        { label: 'Неизвестно',    value: unknown,         icon: '⚪' },
    ];

    return (
        <div className="app-layout">
            <Sidebar />

            <main className="main-content">
                <header className="page-header">
                    <h1>Dashboard</h1>
                    <span className="header-time">
                        {new Date().toLocaleDateString('ru-RU', {
                            weekday: 'long', year: 'numeric',
                            month: 'long',  day: 'numeric',
                        })}
                    </span>
                </header>

                <div className="stats-grid">
                    {stats.map((s, i) => (
                        <div key={i} className="stat-card">
                            <div className="stat-icon">{s.icon}</div>
                            <div className="stat-info">
                                <span className="stat-value">{s.value}</span>
                                <span className="stat-label">{s.label}</span>
                            </div>
                        </div>
                    ))}
                </div>

                {servers.length === 0 ? (
                    <div className="empty-state">
                        <div className="empty-icon">📡</div>
                        <h2>Серверы не добавлены</h2>
                        <p>Перейдите в раздел «Серверы» и добавьте первый</p>
                        <button
                            className="btn-primary"
                            style={{ maxWidth: 240 }}
                            onClick={() => navigate('/servers')}
                        >
                            Перейти к серверам
                        </button>
                    </div>
                ) : (
                    /* Краткий список последних серверов */
                    <div className="dashboard-servers">
                        <div className="section-header">
                            <h2>Серверы</h2>
                            <button className="btn-link" onClick={() => navigate('/servers')}>
                                Все серверы →
                            </button>
                        </div>
                        <div className="server-cards">
                            {servers.slice(0, 6).map(s => (
                                <div
                                    key={s.id}
                                    className={`server-card-mini ${s.status}`}
                                    onClick={() => navigate('/servers')}
                                >
                                    <div className="scm-status-dot" />
                                    <div>
                                        <div className="scm-name">{s.name}</div>
                                        <div className="scm-host">{s.host}</div>
                                    </div>
                                    <div className="scm-latency">
                                        {s.last_latency !== null
                                            ? `${Math.round(s.last_latency)} мс`
                                            : '—'}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </main>
        </div>
    );
}
